<div class="grid flex justify-content-center p-0">
  <div class="col-12 flex py-0">
    <div class="card m-0 shadow-none">
      <div class="card-body m-0">
        <h3
          class="card-title"
          style="color: #0063b9 !important; margin-bottom: 10px"
        >
          Datos de la persona que recibirá el pedido
        </h3>
        <form [formGroup]="formRecibe">
          <div class="row">
            <div class="md:col-6 py-0">
              <div class="mb-3">
                <input
                  formControlName="firstName"
                  type="text"
                  class="form-control"
                  placeholder="Nombres*"
                  appLettersChar
                />
              </div>
            </div>
            <div class="md:col-6 py-0">
              <div class="mb-3">
                <input
                  formControlName="lastName"
                  type="text"
                  class="form-control"
                  placeholder="Apellidos*"
                  appLettersChar
                />
              </div>
            </div>

            <div class="md:col-6 py-0">
              <div class="mb-3">
                <label style="color: #0063b9">Telefono fijo/Celular</label>
                <div class="input-group">
                  <div class="input-group-prepend" dropdown>
                    <button
                      id="button-basic"
                      class="btn btn-outline-secondary dropdown-toggle"
                      type="button"
                      dropdownToggle
                      aria-controls="dropdown-phone"
                    >
                      <i
                        [ngClass]="
                          selectedPhoneCode == config.phoneCodes.mobile.code
                            ? 'fa-solid fa-mobile-screen'
                            : 'fa-solid fa-phone'
                        "
                        style="margin-right: 1px"
                      ></i>
                      {{ selectedPhoneCode }}
                    </button>
                    <div
                      id="dropdown-phone"
                      *dropdownMenu
                      class="dropdown-menu"
                      role="menu"
                      aria-labelledby="button-basic"
                    >
                      <a
                        class="dropdown-item"
                        (click)="Select_fono(config.phoneCodes.mobile.code)"
                        ><i
                          class="fa-solid fa-mobile-screen"
                          style="margin-right: 1px"
                        ></i
                        >{{ config.phoneCodes.mobile.code }}</a
                      >
                      <a
                        class="dropdown-item"
                        (click)="Select_fono(config.phoneCodes.landline.code)"
                        ><i
                          class="fa-solid fa-phone"
                          style="margin-right: 1px"
                        ></i
                        >{{ config.phoneCodes.landline.code }}</a
                      >
                    </div>
                  </div>

                  <input
                    formControlName="phone"
                    type="text"
                    class="form-control"
                    placeholder="Número Contacto*"
                    [maxLength]="maxPhone"
                    (input)="noCharPhone($event)"
                  />
                </div>

                <p
                  *ngIf="
                    formRecibe.controls['phone'].invalid &&
                    formRecibe.controls['phone'].touched
                  "
                  class="text-error-form-2"
                >
                  El número de contacto no es válido
                </p>
              </div>
            </div>
            <div class="md:col-6 py-0">
              <div class="mb-3">
                <label style="color: #0063b9"
                  >{{ config.document.name }}*</label
                >
                @if(country==='pe'){
                <input
                  type="text"
                  formControlName="documentId"
                  class="form-control"
                  [placeholder]="config.document.name + '*'"
                  [maxlength]="documentIdLength"
                  (input)="noCharDni($event)"
                />
                } @else{
                <input
                  type="text"
                  formControlName="documentId"
                  class="form-control"
                  [placeholder]="config.document.name + '*'"
                  [maxlength]="documentIdLength"
                  (blur)="
                    formRecibe.controls['documentId'].setValue(
                      formatRut(formRecibe.controls['documentId'].value)
                    )
                  "
                  (focus)="
                    formRecibe.controls['documentId'].setValue(
                      cleanRut(formRecibe.controls['documentId'].value)
                    )
                  "
                />
                }
                <p
                  *ngIf="
                    formRecibe.controls['documentId'].invalid &&
                    formRecibe.controls['documentId'].touched
                  "
                  class="text-red-500 float-start"
                >
                  El {{ config.document.name }} ingresado no es válido.
                </p>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div
        class="card-footer p-0 flex justify-content-center"
        style="margin-top: 10px"
      >
        <div class="lg:col-12 sm:col-8 p-0">
          <button
            name="aceptar"
            (click)="enviarReceptor()"
            type="button"
            [disabled]="!formRecibe.valid"
            class="btn btn-secondary w-100 text-center"
            name="aceptar"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
